import { Injectable } from '@angular/core';
import { APISCockpit } from 'src/service/apis-cockpit';
import { PoComboFilter, PoComboOption } from '@po-ui/ng-components';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ComponentesUtils } from 'src/utils/components-utils';
import { ContextApplication } from '../contextapplication/contextapplication';

@Injectable({ providedIn: 'root' })
export class ProjectServices implements PoComboFilter {

  private componentsUtils = new ComponentesUtils();
  companyid: number;

  constructor(private apiCockpit: APISCockpit, private contextApplication: ContextApplication) { }

  getFilteredData(param): Observable<Array<PoComboOption>> {
    const params = { name: param.value };
    let ApiProjeto = this.getAPIProject();

    if (params && params.name !== '') {
      ApiProjeto += `&$filter=contains(description, '${params.name}')`;
    }

    if (this.companyid) {
      ApiProjeto += `&companyId=${this.companyid}`;
    }
    else {
      return new Observable<Array<PoComboOption>>();
    }

    ApiProjeto += `&userPermission=${this.contextApplication.Usuario.username}`;

    return this.apiCockpit.getDataInfoObservable(ApiProjeto).pipe(
      map((response: any) => {
        return this.componentsUtils.convertToArrayComboOption(response.items, 'description');
      })
    );
  }

  getObjectByValue(value: any): Observable<PoComboOption> {
    let ApiProjeto = this.getAPIProject();
    if (value && value !== '') {
      ApiProjeto += `&$filter=contains(description, '${value}')`;
    }

    if (this.companyid) {
      ApiProjeto += `&companyId=${this.companyid}`;
    }
    else {
      return new Observable<PoComboOption>();
    }

    ApiProjeto += `&userPermission=${this.contextApplication.Usuario.username}`;

    return this.apiCockpit.getDataInfoObservable(ApiProjeto)
                          .pipe(map(item => this.componentsUtils.convertToComboOption(item, 'description')));
  }

  getAPIProject() {
    return '/api/construction-projects/v1/projects?page=1&pageSize=1000&order=description';
  }

}
